export const FIRMWARE_EXTENSIONS = ['ttfp', 'cmp', 'hpk']

export const OPTIONAL_DEVICE_APPLICATION_EXTENSIONS = ['rpms']

export const DEVICE_APPLICATION_EXTENSIONS = ['uvh', 'rpms', 'gz', 'swu']

export const LICENSE_KEY_EXTENSIONS = ['key']

export const SUPPORTING_APPLICATION_EXTENSTIONS = ['exe']

export const CUSTOMIZATION_PROFILE_EXTENSIONS = ['json']

export const CONFIGURATION_FILE_EXTENSIONS = ['dat']

export const JOB_PHOTO_EXTENSIONS = ['jpg', 'jpeg']

export const SFE_KEY_EXTENSIONS = ['key', 'zip']

export const CSV_EXTENSIONS = ['csv']